import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import useSWR from "swr";

export function useKnownPurchaseAcTags() {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();

  const { isLoading, data } = useSWR(
    "/product/ac-tags/known-purchase-tags",
    async (url) => {
      const { data } = await createAxiosInstance().get<string[]>(url);
      return data;
    },
  );

  return {
    purchaseTags: data ?? [],
    isLoading,
  };
}
